import { callApiWithoutDispatch } from '../../../../../../utils/apiUtils';
import {
  getPayoutFleetMethodsApi,
  withdrawalPreviewGsnApi,
  withdrawalRequestGsnApi,
} from '../../../../../../constants/ApiConfigs';

/**
 * Fetch list of payout methods for fleet (for Pay To dropdown).
 * @param {{ fleetId: string }} params
 * @returns {Promise<Array<{ gateway: string, connectToken?: string, connectStatus?: string }>>}
 */
export async function getPayoutFleetMethods(params) {
  const { fleetId } = params;
  const config = { method: 'POST', body: JSON.stringify({ fleetId }) };
  const json = await callApiWithoutDispatch(getPayoutFleetMethodsApi, config);
  if (json?.error) throw new Error(json.error?.message || json.error);
  const res = json?.res;
  return Array.isArray(res) ? res : [];
}

/**
 * Withdrawal preview – fee and received amount.
 * @param {{ fleetId: string, token: string, amount: number, transferType: string }} params
 * @returns {Promise<{ receivedAmount: number, transFee: number }>}
 */
export async function withdrawalPreviewGsn(params) {
  const { fleetId, token, amount, transferType = '0' } = params;
  const config = {
    method: 'POST',
    body: JSON.stringify({
      fleetId,
      token,
      amount: Number(amount) || 0,
      transferType: Number(transferType),
    }),
  };
  const json = await callApiWithoutDispatch(withdrawalPreviewGsnApi, config);
  // if (json?.error) throw new Error(json.error?.message || json.error);
  // const res = json?.res?.response ?? json?.res;
  // const returnCode = json?.res?.returnCode;
  // if (returnCode !== 200) throw new Error(json?.error?.message || 'Preview failed');
  return json;
}

/**
 * Submit withdrawal request.
 * @param {{ fleetId: string, token: string, amount: number, transferType: number }} params
 * @returns {Promise<*>}
 */
export async function withdrawalRequestGsn(params) {
  const { fleetId, token, amount, transferType = 0 } = params;
  const config = {
    method: 'POST',
    body: JSON.stringify({
      fleetId,
      token,
      amount: Number(amount) || 0,
      transferType: Number(transferType),
    }),
  };
  const json = await callApiWithoutDispatch(withdrawalRequestGsnApi, config);
  if (json?.error) throw new Error(json.error?.message || json.error);
  if (json?.res?.returnCode !== 200) throw new Error(json?.error?.message || json?.res?.message || 'Request failed');
  return json;
}
